import { apiSystem, apiEnv } from './urlConfig';

// Default values in case imports are undefined or null
const DEFAULT_ENV = 'beta';
const DEFAULT_SYSTEM = 'canou';

// Use values from urlConfig if available, otherwise use defaults
let envValue = apiEnv || DEFAULT_ENV;
let systemValue = apiSystem || DEFAULT_SYSTEM;

// Base API URLs for different environments
const API_URLS = {
    dev: "https://fusionapi.de/dev_mk/v3/api/v3",
    beta: "https://fusionapi.de/beta/v3/api/v3",
    live: "https://fusionapi.de/live/v3/api/v3"
};

const API_SYSTEMS = {
    "canou Beta"    :   "$2y$10$c38BmQdrRPG1h4NVTTxZ/OXjtzfpu/m3hYHmCJJehPf4bMJ3vOdDC",
    "canou"         :   "$2y$10$pp99K2PZDZicDKH8ctEbRuLtm9kvjnL1H/3RVKJYZS4PYrH0qEWkC",
    "work"          :   "$2y$10$2TJf5F2YDi46Ro61jw5IKupHoEdKol7tt.g916X.76iWi6QqWe2LK",
    "tasty"         :   "$2y$10$4FzeFSSiNSBymrQ/c.I2/.0Wk7rqDeMDb.40Z4m0pW8/sAiaaxND6",
    "digitalbash"   :   "$2y$10$0b9yV/9ChuBGnf3xQaG8gOpBvRW.B15tOLbPtyy/2LZBfLhzI8zRG"
};

// Check if environment is valid
if (!API_URLS[envValue]) {
    console.error('Invalid environment:', envValue, 'Falling back to', DEFAULT_ENV);
    envValue = DEFAULT_ENV;
}

// Check if system is valid
if (!API_SYSTEMS[systemValue]) {
    console.error('Invalid system:', systemValue, 'Falling back to', DEFAULT_SYSTEM);
    systemValue = DEFAULT_SYSTEM;
}

// Export API URL and other constants
export const ENV = envValue;
export const SYSTEM = systemValue;
export const API_URL = API_URLS[ENV];
export const API_ENV = ENV;
export const STK = API_SYSTEMS[SYSTEM];

// Optional: Debug logging
ENV === 'dev' && console.warn(`API running in ${ENV} mode: ${API_URL}`);
